import { ThemeColors } from '../types/user';

export const defaultThemeColors: ThemeColors = {
  primary: '#0A84FF',      // Contemporary blue
  secondary: '#8E8E93',    // Neutral gray
  tertiary: '#5E5CE6',     // Soft violet
  quaternary: '#30D158',   // Fresh green
  accent1: '#BF5AF2',      // Muted purple
  accent2: '#32D74B',      // Accent green
  background: '#ffffff',
  surface: '#F8F8F8',
  surfaceAlt: '#F2F2F2',
  text: '#111827',
  textSecondary: '#4B5563',
  border: '#E5E7EB',
  success: '#059669',
  error: '#DC2626',
  warning: '#D97706',
  info: '#2563EB',
  shadow: '#000000',
  logo: {
    primary: '#54a066',
    secondary: '#0A84FF',
    tertiary: '#616e81',
    accent: '#2f784c',
    highlight: '#c3cfb5'
  }
};
